import React from 'react';
import { FileVersionsModal } from './FileVersionsModal';
import { useCsvFileVersions } from '@/services/csvFilesHooks';
import { CsvFileVersion } from '@/types/csvFiles';
import { getCsvFileVersionDownloadEndpoint } from '@/utils/downloadEndpoints';
import type { BaseFile } from './types';

interface CsvFileVersionsModalProps {
  file: BaseFile | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Wrapper component for CsvFile version history modal
 * Uses generic FileVersionsModal with CsvFile-specific configuration
 */
const CsvFileVersionsModal: React.FC<CsvFileVersionsModalProps> = ({
  file,
  open,
  onOpenChange,
}) => {
  return (
    <FileVersionsModal<BaseFile, CsvFileVersion>
      file={file}
      open={open}
      onOpenChange={onOpenChange}
      useVersionsHook={useCsvFileVersions}
      getDownloadEndpoint={getCsvFileVersionDownloadEndpoint}
      modalTitle="Version History"
      modalSize="medium"
      showExtensionColumn={true}
    />
  );
};

export default CsvFileVersionsModal;
